import { useMemo } from 'react';
import { SOCIAL_PLATFORMS, getAvailablePlatforms, getPlatformById } from '../constants/SocialPlatforms';
import type { SocialPlatform } from '../components/icons/SocialIcon';

export const useSocialPlatforms = () => {
  const allPlatforms = useMemo(() => SOCIAL_PLATFORMS, []);
  const availablePlatforms = useMemo(() => getAvailablePlatforms(), []);

  const getPlatform = (id: SocialPlatform) => {
    return getPlatformById(id);
  };

  return {
    allPlatforms,
    availablePlatforms,
    getPlatform
  };
};